module.exports = __webpack_public_path__ + "7fb37113d6134e09a17ca26600ceb509.fbx";